import React, { useCallback } from 'react';
import ResetPasswordForm from './ResetPasswordForm';
import NewPasswordForm from './NewPasswordForm';

function ResetPassword({ setActiveForm }) {
    const [isFormSended, onSendForm] = React.useState(false);
    const [userEmail, updateUserEmail] = React.useState('');

    const onUserChange = useCallback(({ target }) => updateUserEmail(target.value), [
        updateUserEmail,
    ]);

    return !isFormSended ? (
        <ResetPasswordForm
            onSendForm={onSendForm}
            updateUserEmail={onUserChange}
            userEmail={userEmail}
            setActiveForm={setActiveForm}
        />
    ) : (
        <NewPasswordForm userEmail={userEmail} setActiveForm={setActiveForm} />
    );
}

export default ResetPassword;
export { ResetPassword };
